<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            打印分类
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="danger" :disabled="disabledEdit" plain @click.native="toggleModalEdit">修改</el-button>
                    <div style="float:right">
                        <template>
                            <el-select v-model="institutionCode" filterable clearable  placeholder="请选择">
                            <el-option
                                v-for="item in institutionValue"
                                :key="item.institutionCode"
                                :label="item.name"
                                :value="item.institutionCode">
                                </el-option>
                            </el-select>
                            <el-select v-model="status" placeholder="请选择">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </template>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" highlight-current-row @row-click='rowClick' :height="th" border style="width: 100%;">

                        <el-table-column prop="name" label="文件名称"></el-table-column>
                        <el-table-column prop="url" label="文件路径"></el-table-column>
                        <el-table-column prop="status" label="状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status==1">正常</span>
                                <span v-if="scope.row.status==2">废弃</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="institution" label="机构名称">
                            <template slot-scope="scope">
                                <span v-if="scope.row.institution==null">机构通用</span>
                                <span v-if="scope.row.institution!=null">{{scope.row.institution.name}}</span>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

     import Edit from "./Edit";
     import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "PrintClass",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                showModalEdit:false,
                disabledEdit:true,
                searchDishes:'',
                row:null,
                tableData:null,
                institutionCode:"",
                institutionValue:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                options: [{
                    value: -1,
                    label: '全部'
                    }, {
                    value: 1,
                    label: '正常'
                    }, {
                    value: 2,
                    label: '废弃'
                    }],                                                                                 
                status:-1,
            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.getList();
            this.getInstitutionList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },

        },
        methods:{
            rowClick(val) {
                this.row = val;
                this.disabledEdit=false;
            },
            getInstitutionList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Institution/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.institutionValue = response.data.data.listInstitution;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
                this.$refs.myEdit.init(this.row);
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            
            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"PrintClass/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        status:this.status,
                        institutionCode:this.institutionCode,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.disabledEdit=true;
                    this.loading =false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                        
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    this.disabledEdit=true;
                    console.log(error);
                });
            },



        }
    }
</script>

<style scoped>

</style>
